import Vue from 'vue'
import Router from 'vue-router'
import New from '@/components/views/new/new.vue'
import NewInfo from '@/components/views/new-info/new-info.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'new',
      component: New
    },
    {
      path: '/detail',
      name: 'detail',
      component: NewInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js